import moment from "moment";
import { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import currency from 'currency.js';
import useDidMountEffect from '../utils/useDidMountEffect';
import { PerformanceContext } from './PUHomepage/PerformanceWidget/PerformanceContext';
import { CircularProgress } from '@mui/material';

const Payment = () => {
    const [payments, setPayments] = useState([]);
    const [busy, setBusy] = useState(false);

    const { period, setTotal } = useContext(PerformanceContext);


    const getPayments = () => {
        setBusy(true);
        axios.get('/api/performances/payments', {
            params: {
                period
            }
        })
            .then((response) => {
                setPayments(response.data);
                let tmp = 0;

                if (response.data && response.data.length > 0) {
                    tmp = response.data.reduce((acc, cur) => {
                        const val = parseFloat(cur.pu_total);
                        if (!isNaN(val)) {
                            return acc + val;
                        }
                    }, 0);
                }

                setTotal(tmp);
                setBusy(false);
            })
            .catch(error => {
                setBusy(false);
            });
    };

    useEffect(() => {
        getPayments();
    }, []);

    useDidMountEffect(() => {
        if (period) {
            getPayments();
        }
    }, [period]);

    return <table className="table" style={
        payments && payments.length > 0 ? { minWidth: '450px' } : {}
    }>
        <thead className="sticky white-bg">
            <tr>
                <th><b>Date Time </b></th>
                <th><b>Amount</b></th>
                <th><b>Fee</b></th>
                <th><b>Net</b></th>
                <th><b>Type</b></th>
                <th><b>User</b></th>
            </tr>
        </thead>
        <tbody>
            {
                busy ? <tr>
                    <td colSpan={6} className="text-center">
                        <CircularProgress size={20} />
                    </td>
                </tr> : null
            }
            {
                !busy && payments && payments.length > 0 ?
                    payments.map(payment => {
                        return <tr key={payment.id}>
                            <td>
                                {
                                    moment.utc(payment.created_date)
                                        .local()
                                        .format('MMM DD, YYYY hh:mm a')
                                }
                            </td>
                            <td>
                                {currency(payment.amount, { precision: 2 }).format()}
                            </td>
                            <td>
                                {currency(payment.fees, { precision: 2 }).format()}
                            </td>
                            <td>
                                {currency(parseFloat(payment.amount) + parseFloat(payment.fees), { precision: 2 }).format()}
                            </td>
                            <td>
                                {
                                    payment.transaction_type.toUpperCase() === 'SUBSCRIPTION' ? 'SUB' : ''
                                }
                                {
                                    payment.transaction_type.toUpperCase() === 'SEND TIP' ? 'TIP' : ''
                                }
                                {
                                    !['SEND TIP', 'SUBSCRIPTION'].includes(payment.transaction_type.toUpperCase())
                                        ? payment.transaction_type.toUpperCase()
                                        : ''
                                }
                            </td>
                            <td>
                                {
                                    payment.to_pay_user && payment.to_pay_user.login
                                        ? <Link to={`/${payment.to_pay_user.login}`}>
                                            {payment.to_pay_user.login}
                                        </Link>
                                        : 'Removed User'
                                }
                            </td>
                        </tr>;
                    })
                    : null
            }

            {
                !busy && payments && payments.length === 0
                    ? <tr>
                        <td colSpan="6">
                            No payments found.
                        </td>
                    </tr>
                    : null
            }
        </tbody>
    </table>;
};

export default Payment;
